import { Header } from "../organism/Header";
import Home from "../pages/Home"
import { useReveal } from "../atoms/util/reveal/useReveal";
import "../atoms/util/reveal/reveal.css";

export default function DefaultLayout(){
    useReveal();
    return(
        <>
        <Header/>
        <Home/>
        </>
    )
}
